import 'css-chunksrc/client/scenes/notifications/styles.scss';export default {
  "notifications": "_notifications_s9bw2_1",
  "iconBox": "_iconBox_s9bw2_5",
  "icon": "_icon_s9bw2_5",
  "notificationMark": "_notificationMark_s9bw2_17",
  "popup": "_popup_s9bw2_28",
  "list": "_list_s9bw2_42",
  "placeholder": "_placeholder_s9bw2_49",
  "main": "_main_s9bw2_57",
  "seeAll": "_seeAll_s9bw2_61"
};